import React from "react";
import styles from "./Sobre.module.css";
import iconInstagramSobre from "./icon/icon-instagram.png";

const Sobre = () => {
  return (
    <div className={styles.container}>
      <h1 className={styles.h1}>Sobre o Fohattech</h1>

      <p className={styles.texto}>
        O <strong>Fohattech</strong> é uma plataforma criada com o objetivo de oferecer 
        ferramentas web simples, rápidas e acessíveis para desenvolvedores, designers 
        e qualquer pessoa que precise de soluções práticas no dia a dia.
      </p>

      <p className={styles.texto}>
        Aqui você encontra utilidades que vão desde cálculos básicos, como o cálculo 
        de IMC, até integrações com APIs externas, como a busca de imagens da NASA. 
        Todas as ferramentas são desenvolvidas com foco em desempenho, usabilidade e 
        facilidade de uso, sem necessidade de instalação.
      </p>

      <h2 className={styles.subtitulo}>Nosso objetivo</h2>

      <p className={styles.texto}>
        O principal objetivo do Fohattech é centralizar ferramentas úteis em um único 
        lugar, permitindo que usuários encontrem soluções rápidas sem complicação. 
        A plataforma está em constante evolução, com novas funcionalidades sendo 
        adicionadas regularmente.
      </p>

      <h2 className={styles.subtitulo}>Para quem é o Fohattech?</h2>

      <p className={styles.texto}>
        O Fohattech foi desenvolvido para:
      </p>

      <ul className={styles.lista}>
        <li>Desenvolvedores que precisam de ferramentas rápidas</li>
        <li>Designers em busca de recursos práticos</li>
        <li>Estudantes que estão aprendendo tecnologia</li>
        <li>Usuários comuns que querem soluções simples online</li>
      </ul>

      <h2 className={styles.subtitulo}>Tecnologias utilizadas</h2>

      <p className={styles.texto}>
        O projeto é desenvolvido utilizando tecnologias modernas como React.js, 
        garantindo uma experiência rápida, dinâmica e responsiva em diferentes dispositivos.
      </p>

      <h2 className={styles.subtitulo}>Contato e redes sociais</h2>

      <p className={styles.texto}>
        Você pode acompanhar atualizações, novidades e novas ferramentas através do Instagram:
      </p>

      <p className={styles.texto3}>
        Siga o Fohattech no{" "}
        <a href="https://www.instagram.com/fohattech/" target="_blank" rel="noreferrer">
          Instagram
        </a>
      </p>

      <a href="https://www.instagram.com/fohattech/" target="_blank" rel="noreferrer">
        <img className={styles.iconInstagram} src={iconInstagramSobre} alt="Instagram Fohattech" />
      </a>
    </div>
  );
};

export default Sobre;